<template>
    <div class="VideoInfo">
        <el-row>
            <el-col :span="24">
                <el-button style="padding: 0; margin: 20px" type="text" icon="el-icon-back" @click="$router.go(-1)">
                    返回
                </el-button>
            </el-col>
        </el-row>
        <el-form :model="meetStoryInfo" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="标题" prop="title">
                <el-input v-model="meetStoryInfo.title" maxlength="30" show-word-limit style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="category_id">
                <el-select v-model="meetStoryInfo.category_id" placeholder="请选择分类" style="width:33%">
                    <el-option
                        v-for="item in meetStoryCategory"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="封面">
                <el-upload class="avatar-uploader" :action="ossAction" :show-file-list="false" :http-request="uploadOSSRequest"
                           :before-upload="beforeImageUpload">
                    <img v-if="meetStoryInfo.img_url" :src="meetStoryInfo.img_url" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="el-upload__tip">
                        只能上传jpg/png文件，且不超过500kb
                    </div>
                </el-upload>
            </el-form-item>

            <el-form-item label="学习人数" prop="number">
                <el-input v-model="meetStoryInfo.study_number" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model="meetStoryInfo.sort" style="width:33%" @input="validateInput4"></el-input>
            </el-form-item>
            <el-form-item label="点赞数" prop="sort">
                <el-input size="mini" v-model="meetStoryInfo.virtual_like_number" @input="validateInput" autocomplete="off" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="转发数" prop="sort">
                <el-input size="mini" v-model="meetStoryInfo.virtual_relay_number" @input="validateInput2" autocomplete="off" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="上传视频">
                <el-button type="primary" @click="addcerlist">
                    添加视频
                </el-button>
                <el-col :span="24">
                    <div v-for="(i, v) in meetStoryInfo.videos" :key="v" style="display: flex; " class="VideoUp">
                        <div>
                            视频名称:
                            <el-input size="mini" v-model="i.title" style="width: 20%;" maxlength="30" show-word-limit placeholder="请输入视频名称"></el-input>
                        </div>
                        <div class="img_video" style="min-width: 800px;">
                            <div class="" style="margin-right: 42px; width: 200px;">
                                <upload_video @uploadvideoSuccess="uploadvideoSuccess" :video_url="i.mp4" :type="100" :id="i.id" @uploadvideoduration="uploadvideoduration" />
                                <div style="font-size: 12px; margin-top:19px; color: #606266 ;">视频大小限制100M 格式为MP4</div>
                            </div>
                            <div style="width: 64%;">
                                <certificateupload :tip="'只能上传JPG/PNG文件，且不超过500kb'" :formName="i.title" :formValue="i.img" :id="i.id"
                                                   @uploadSuccess="uploadSuccess2" @deleteList="deleteList" :num="meetStoryInfo.videos.length"
                                                   :source="'meetvideo'" >
                                </certificateupload>
                            </div>
                        </div>
                        <div>视频排序:
                            <el-input size="mini" v-model="i.sort" style="width: 20%;" @input="validateInput3(i)" placeholder="请输入视频排序"></el-input>
                        </div>
                    </div>
                    <!-- <el-button size="mini" @click="addcerlist" v-if="isbtnshow">添加证书</el-button> -->
                </el-col>
            </el-form-item>
            <el-form-item label="副标题" class="is-required">
                <el-input v-model="meetStoryInfo.subtitle" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="上课地点" class="is-required">
                <el-input v-model="meetStoryInfo.class_address" style="width:33%"></el-input>
            </el-form-item>
            <el-form-item label="上课日期" class="is-required">
                <el-date-picker v-model="meetStoryInfo.start_at" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间">
                </el-date-picker>~
                <el-date-picker v-model="meetStoryInfo.end_at" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" @click="
            createUpdateMeetStory()
          " :loading="updateLoading" >确 定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import tinymce from "@/components/tinymce.vue";
import certificateupload from "@/components/certificateupload.vue";
import upload_video from "@/components/upload_video.vue";
import {
    beforeImageUpload,
    uploadOSSRequest,
    getAliyunOssToken,
} from "@/api/common";

import { createUpdateMeetStory, getMeetStoryInfo ,createUpdateMeetStoryVideo, getAllMeetStoryCategory} from "@/api/story";

export default {
    data: function () {
        return {
            isshow: false,
            ossAction: "",
            ossData: {},
            loading: false,
            aliyunOssToken: "",
            updateLoading: false,
            editor: null,
            meetStoryInfo: {
                id: 0,
                category: this.$route.query.category,
                title: "",
                img: "",
                content: "",
                study_number: 0,
                sort: 0,
                subtitle: "",
                class_address: "",
                start_at: "",
                end_at: "",
                virtual_like_number: 0,
                virtual_relay_number: 0,
                videos: [], // 资格证书
                category_id: null,
            },
            dialogVisible: false,
            dialogVisible2: false,
            meetStoryCategory: [],
            categoryType:{
                type:1,
            }
        };
    },
    components: {
        tinymce,
        certificateupload,
        upload_video,
    },
    created: function () {
        this.getAllMeetStoryCategory()
        this.meetStoryInfo.id = this.$route.query.id;
        if (this.meetStoryInfo.id > 0) {
            this.getInfo();
        }
    },
    mounted() {},
    computed: {},
    methods: {
        validateInput(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.meetStoryInfo.virtual_like_number = value;
        },
        validateInput2(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.meetStoryInfo.virtual_relay_number = value;
        },
        validateInput3(event,i) {
            console.log(event);

            let value = event.sort;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            event.sort = value;
        },
        validateInput4(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.meetStoryInfo.sort = value;
        },
        handleClose(done) {
            this.$confirm("确认关闭？")
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        onVideoSubmit() {},
        addcerlist() {
            // 添加资格证书
            console.log(
                this.meetStoryInfo.videos.length,
                "-",
                this.arrayLength
            );
            const obj = {
                title: "",
                img: "",
                id: Date.now() + 55,
                mp4: "",
                sort: this.meetStoryInfo.videos.length + 1,
                duration: "",
            };
            this.meetStoryInfo.videos.push(obj);

            console.log(this.meetStoryInfo.videos);
        },
        deleteList(value) {
            const indexToDelete = this.meetStoryInfo.videos.findIndex(
                (obj) => obj.id === value.id
            );

            // 如果找到了匹配的对象
            if (indexToDelete != -1) {
                this.meetStoryInfo.videos.splice(indexToDelete, 1);
            }
        },
        beforeImageUpload(file) {
            beforeImageUpload(file);
        },
        uploadOSSRequest(file) {
            getAliyunOssToken({ dir: "" }).then((res) => {
                uploadOSSRequest(file.file, res.data).then((fileUrl) => {
                    this.meetStoryInfo.img_url = fileUrl;
                });
            });
        },

        getInfo() {
            this.loading = true;
            getMeetStoryInfo({
                id: this.meetStoryInfo.id,
            }).then((response) => {
                this.meetStoryInfo = response.data;
                // this.meetStoryInfo.videos = JSON.parse(this.meetStoryInfo.videos);
                console.log(this.meetStoryInfo.videos.map((v) => v.mp4));
                this.loading = false;
            });
        },
        createUpdateMeetStory() {
            if (!this.meetStoryInfo.category_id) {
                this.$message({
                    message: "请选择分类",
                    type: "error",
                });
            }
            this.updateLoading = true;
            console.log("this.meetStoryInfo.videos", this.meetStoryInfo.videos);
            if (!this.validateField(this.meetStoryInfo.videos, "视频")) {
                this.updateLoading = false;
                return;
            }
            if (!this.validateCetrs(this.meetStoryInfo.videos)) {
                this.$message({
                    message: "请填写完整视频信息",
                    type: "error",
                });
                this.updateLoading = false;
                return;
            }
            createUpdateMeetStoryVideo(this.meetStoryInfo)
                .then((response) => {
                    this.updateLoading = false;
                    console.log(
                        response.code,
                        this.validateCetrs(this.meetStoryInfo.videos)
                    );
                    if (response.code == 1) {
                        this.$message.success(response.message);
                        this.$router.push({
                            path: "/story/meetStoryList",
                            query: {
                                category: this.$route.query.category,
                            },
                        });
                    }
                })
                .catch((err) => {
                    this.updateLoading = false;
                });
        },

        ref() {
            window.history.go(-1);
        },
        uploadSuccess2(value) {
            
            const foundObject = this.meetStoryInfo.videos.find(
                (obj) => obj.id === value.id
            );
            // console.log(foundObject);
            const fileExtension = value.fileUrl.split(".").pop().toLowerCase();

            // 判断是否是图片格式
            const isImageFormat = ["png", "jpeg", "jpg", "gif", ""].includes(
                fileExtension
            );

            if (isImageFormat) {
                console.log("是图片格式");
                foundObject.img = value.fileUrl;
            } else {
                this.$message({
                    message: "请上传图片格式文件",
                    type: "error",
                });
                return;
            }
        },
        uploadvideoduration(value) {
            this.updateLoading = true;
        },
        uploadvideoSuccess(value) {
            
            console.log(value, "---------",this.dialogVisible2);
            const foundObject = this.meetStoryInfo.videos.find(
                (obj) => obj.id === value.id
            );
            console.log(foundObject, "]]]]");
            this.getVideoDuration(value);

            if (
                value.fileUrl.toLowerCase().endsWith(".mp4")
            ) {
                // this.info.video_url = value.fileUrl;

                foundObject.mp4 = value.fileUrl;
                
                console.log(
                    value.fileUrl +
                        "?x-oss-process=video/snapshot,t_0,f_jpg,w_500,m_fast,ar_auto",
                    "==+++"
                );
            } else {
                console.log("这不是一个 MP4文件");
                // this.meetStoryInfo.videos.video_url = "";
            }
        },
        validateCetrs(cetrs) {
            // 如果数组为空，直接返回 true
            if (cetrs.length === 0) {
                return true;
            }

            // 遍历数组中的每个对象
            for (let item of cetrs) {
                // 检查每个对象的 id、title 和 img_url 是否都不为空
                if (
                    !item.id ||
                    !item.title ||
                    !item.img ||
                    !item.mp4 ||
                    !item.sort
                ) {
                    return false; // 如果有任何一个为空，返回 false
                }
            }

            // 如果所有对象的 id、title 和 img_url 都不为空，返回 true
            return true;
        },
        validateField(data, fieldName, errorMessage) {
            if (data.length === 0) {
                this.$message({
                    message: `请至少添加一个${fieldName}`,
                    type: "error",
                });
                return false;
            }

            return true;
        },
        getVideoDuration(value) {
            // 获取视频时长的函数
            // 创建一个 video 元素
            
            
            console.log(value,'value0',this.updateLoading);
            const foundObject = this.meetStoryInfo.videos.find(
                (obj) => obj.id === value.id
            );
            var video = document.createElement("video");
            // 设置 video 的 src 属性为输入框中的链接
            video.src = value.fileUrl;
            console.log(video.src,'video.src');
            
            // 等待视频元数据加载完成后
            video.addEventListener("loadedmetadata", () => {
                // 获取视频的时长（秒）
                var duration = video.duration;
                console.log("视频时长（秒）：", duration);
                foundObject.duration = parseInt(duration)
                this.updateLoading = false;
                console.log(this.updateLoading,'this.dialogVisible2');
                
                // 可以将时长格式化成更友好的时间格式，例如：hh:mm:ss
                // var formattedTime = this.formatTime(duration);
                // console.log("格式化后的时长：", formattedTime);
            });

            // 加载视频元数据
            video.load();
        },
        getAllMeetStoryCategory() {
            // this.loading = true;
            getAllMeetStoryCategory(this.categoryType).then((response) => {
                this.meetStoryCategory = response.data;
                // this.loading = false;
            });
        },
    },
};
</script>
<style>
.VideoInfo .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.VideoInfo .avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.VideoInfo .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.VideoInfo .avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.VideoInfo .hides {
    background: #fff;
    width: 100px;
    height: 100px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
}
.VideoInfo .VideoUp {
    display: flex;
    flex-direction: column;
}
.VideoInfo .VideoUp .img_video {
    display: flex;
}
.VideoInfo .VideoUp .avatar-uploader-icon {
    width: 120px;
    height: 120px;
}
.VideoInfo .VideoUp .avatar-uploader-icon {
    line-height: 120px;
}
.VideoInfo .VideoUp .avatar {
    width: 120px;
    height: 120px;
    display: block;
    object-fit: cover;
}
</style>